import { METHOD, webRequest } from '../../client/HttpClient';
import { API } from '../../client/RouteConstants';
import { buildURL, logAPIErrorToNewrelic } from '../utils';
import { ACTION, Analytics } from '../../analytics/analytics';
import { APIResult } from '../APIResult';

export const deleteWishListProduct = async (productId: string): Promise<APIResult<WishListItem[]>> => {
    const url = buildURL(`${API.WISH_LISTS}/product/${productId}?productMode=true&includesImages=true`);

    const request: RequestInit = {
        method: METHOD.DELETE,
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const res = await webRequest(url, request);

    const result = new APIResult<WishListItem[]>();
    if (!res) {
        logAPIErrorToNewrelic(`deleteWishListProduct`, `No response`, {
            productId,
            ...request,
            url: url,
            response: res,
        });
        return result;
    }

    if (res.status === 401) {
        result.showError = false;
    }

    if (res.ok) {
        Analytics.dispatchAdobeAnalytics(ACTION.REMOVE_FROM_WISH_LIST);
        const customEvent = new CustomEvent('ADD_TO_WISHLIST_ESI:REMOVE_SUCCESS', {
            detail: {
                code: 'wishlist remove success',
            },
        });
        window.dispatchEvent(customEvent);
        result.data = ((await res.json()) as WishlistResponse).wishLists;
        result.success = true;
    } else {
        logAPIErrorToNewrelic(`deleteWishListProduct`, `Not Ok response`, {
            productId,
            request: request,
            reqUrl: url,
            ...res,
        });
    }

    return result;
};
